import useInstalledPlugins from "../../../hooks/useInstalledPlugins";
import useWriteModel from "../../../hooks/useWriteModel";
import { resolveBenchmarkWriteModel } from "../../BenchmarkTakeover/proseMode";
import { useStoryBibleStore } from "../../../stores/storyBibleStore";
import { NewDocumentCtaContainer, StyledButton } from "./styles";
import SVG from "react-inlinesvg";
import { BLOCK_TYPES } from "../../../../../src/shared/schemas/PluginSchema";
import { makeId } from "../../../Utils";
import { useProjectStore } from "src/stores/projectStore";

export function NewDocumentCTAs({ editorOptions, openWormhole, runDocumentPluginAction, documentPluginBridge }) {
  const setProseGeneratorActive = useStoryBibleStore((state) => state.setProseGeneratorActive);
  const setShowLinkingMenu = useProjectStore((state) => state.setShowLinkingMenu);
  const { installedPlugins: pluginSchemas } = useInstalledPlugins();
  const selectedWriteModel = useWriteModel({ editorOptions });

  const runWriteButton = () => {
    // original args are guidance, sessionId, nonce
    const modeToUse = "auto"; // in this case we are using auto mode, since its a new doc
    const nonce = makeId(15);
    const writePlugins = pluginSchemas
      .map((s) => {
        const [, type, mode, model] = s.plugin.id.split("/"); // i.e. 'documentPlugins/writeClaude3/auto/claude3haiku'
        return {
          plugin: s.plugin,
          mode,
          model,
          type,
        };
      })
      .filter((s) => (s.type === "write" || s.type === "writeClaude3") && s.mode === modeToUse && s.model === resolveBenchmarkWriteModel(selectedWriteModel));
    const plugin = writePlugins[0]?.plugin;
    if (!plugin) return;
    const inputDocumentBlock = plugin.blocks.find((block) => block.blockType === BLOCK_TYPES.INPUT_DOCUMENT);
    if (!inputDocumentBlock) return;
    const params = openWormhole({ constructOnly: true, sessionId: `new-doc-write-${nonce}`, forcedOutputCards: 3 });
    runDocumentPluginAction(inputDocumentBlock, plugin, documentPluginBridge, true, params, nonce);
  };

  return (
    <NewDocumentCtaContainer>
      <StyledButton
        className="use-component-styles"
        onClick={() => {
          setShowLinkingMenu(false);
          setProseGeneratorActive(true);
        }}
        aria-label="Generate a Rough Draft"
      >
        <SVG
          src="/assets/story-bible/generator.svg"
          width={24}
          height={24}
        />
        <p>Generate a Rough Draft</p>
      </StyledButton>
      <StyledButton
        className="use-component-styles"
        onClick={runWriteButton}
        aria-label="Create 3 openings"
      >
        <SVG
          src="/assets/write.svg"
          width={24}
          height={24}
        />
        <p>Generate 3 Openings</p>
      </StyledButton>
    </NewDocumentCtaContainer>
  );
}
